var React = require('react');

function IconMinus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1H13","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"}));
}

IconMinus.defaultProps = {"viewBox":"0 0 14 2","fill":"none"};

module.exports = IconMinus;

IconMinus.default = IconMinus;
